import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const TelematicDeviceDashboard = lazyLoader(
  () =>
    import(
      "Containers/TelematicDevice/TelematicDeviceDashboard/TelematicDeviceDashboard"
    )
);

export const TelematicDeviceListPage: React.FC = () => {
  return (
    <Layout>
      <TelematicDeviceDashboard />
    </Layout>
  );
};
